import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getCampos = createAsyncThunk(
  "matrizConfigApp/camposDetalhe/getCampos",
  async (data: object, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/matriz-campos", {
        params: data,
      });
    } catch (err) {
      dispatch(openModalError({
        title: "Não foi possível buscar os campos!",
        text: "Se certifique que os dados digitados estão corretos",
        btnLabel: "Voltar"
      }));
      console.error(err);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const saveCampo = createAsyncThunk(
  "matrizConfigApp/camposDetalhe/saveCampo",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.post("/matriz-campos", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Campo cadastrado",
        })
      );
      dispatch(
        getCampos(
          requestGetParams.matrizConfigApp.camposDetalhe.requestGetParams
        )
      );
    } catch (err) {
      dispatch(openModalError({
        title: "Não foi possível cadastrar o campo!",
        text: "Se certifique que os dados digitados estão corretos",
        btnLabel: "Voltar"
      }));
      console.error(err);
    }
    return {};
  }
);

export const editCampo = createAsyncThunk(
  "matrizConfigApp/camposDetalhe/editCampo",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.put("/matriz-campos", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Campo editado",
        })
      );
      dispatch(
        getCampos(
          requestGetParams.matrizConfigApp.camposDetalhe.requestGetParams
        )
      );
    } catch (err) {
      dispatch(openModalError({
        title: "Não foi possível editar o campo!",
        text: "Se certifique que os dados digitados estão corretos",
        btnLabel: "Voltar"
      }));
      console.error(err);
    }
    return {};
  }
);

export const deleteCampo = createAsyncThunk(
  "matrizConfigApp/camposDetalhe/deleteCampo",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    const { idNomeCampo } = data;
    try {
      await API.delete(`/matriz-campos/${idNomeCampo}`);
      dispatch(
        openToast({
          severity: "success",
          title: "Campo removido",
        })
      );
      dispatch(
        getCampos(
          requestGetParams.matrizConfigApp.camposDetalhe.requestGetParams
        )
      );
    } catch (err) {
      dispatch(openModalError({
        title: "Não foi possível remover o campo!",
        text: "Se certifique que a solicitação está correta",
        btnLabel: "Voltar"
      }));
      console.error(err);
    }
    return {};
  }
);
